import React, { Component }         from 'react';
import moment                       from 'moment';
import { Redirect }                 from 'react-router-dom';
import { connect }                  from 'react-redux';
import { Field, reduxForm, reset }  from 'redux-form';
import { Link }                     from 'react-router-dom';
import renderField                  from '../../../../container/renderField';
import renderFieldSelec             from '../../../../container/renderFieldSelect';
import renderDatePicker             from '../../../../container/renderDatePicker';
import validate                     from '../../../../service/validade_missoes';
import { SetEditarAtividades,
         GetObterAtividade,
          GetEditarAtividades }               from '../../../../actions/atividadesAction';
import { SetError }                 from '../../../../actions/notificacaoAction';
import { GetListaMenuTopo,
         GetListaSubMenuTopo}      from '../../../../actions/scopoAction';


class MissoesEditar extends Component {

    constructor(props){
        super(props);
        this.state = {
                       redirect   : false,
                       habilitar  : true,
                       use_id     : this.props.session.id,
                       textButton : 'Editar',
                       ati_id     : 0
                      }
    }

    getTipoAtividade(ati_tipo){
      const retorno = {}
          switch(ati_tipo) {                  
                  case this.props.menu.desafios.jogo.tipo1:
                    retorno.tipo = this.props.menu.desafios.jogo.jogo1;
                    break;
                  case this.props.menu.desafios.jogo.tipo2:
                    retorno.tipo = this.props.menu.desafios.jogo.jogo2;
                    break;
                  case this.props.menu.desafios.jogo.tipo3:
                    retorno.tipo = this.props.menu.desafios.jogo.jogo3;
                    break;
                  default:
                  break; 
          }
          return retorno.tipo;
    }

    componentWillMount() {


      this.props.GetEditarAtividades(this.props.match.params.id).then((response)=>{
       const dados = response.data.atividade;
       this.props.initialize({
                             ati_titulo   : dados.ati_titulo,
                             ati_data_ini : moment(dados.ati_data_inicio).format('DD/MM/YYYY'),
                             ati_data_fim : moment(dados.ati_data_fim).format('DD/MM/YYYY'),
                             ati_id       : dados.ati_id,
                             ati_qtd_ten  : parseInt(dados.ati_qtd_tentativas),
                             });

      this.setState({
                        ati_data_inicio : dados.ati_data_inicio,
                        ati_data_fim    : dados.ati_data_fim,
                        ati_id          : dados.ati_id,
                        tipo            : dados.ati_tipo,
                        disciplina      : `${response.data.turma.tur_nome} - ${response.data.disciplina.dis_nome}`,
                      });
      }).catch((error)=>{
        this.props.SetError(500);
      });

    
      

      this.props.GetListaMenuTopo([
        {action:true,nome:"Home",link:this.props.menu.home},
        {action:true,nome:this.props.menu.desafios.nomeModulo,link:this.props.menu.desafios.home},
        {action:false,nome:'Editar desafio'}
        ]);

      this.props.GetListaSubMenuTopo([]); 



    }

    handleSubmit(e){
         var acaoForm = { 
                          ati_titulo         : e.ati_titulo,
                          usu_id             : this.props.session.id,
                          ati_qtd_tentativas : parseInt(e.ati_qtd_ten),
                          ati_data_inicio    : moment(this.state.ati_data_inicio).format('YYYY-MM-DD'),
                          ati_data_fim       : moment(this.state.ati_data_fim).format('YYYY-MM-DD'),
                          ati_id             : this.state.ati_id
                         }
         this.setState({textButton:'Enviando...'})    
         
           this.props.SetEditarAtividades(acaoForm).then((response)=>{  
             alert('Ação realizada com sucesso!');
             this.setState({redirect:true});
           }).catch((error)=>{
                this.props.SetError(500);
           });
    }

    dataInicioChange(e){
      this.setState({ati_data_inicio:moment(e, 'YYYY-MM-DD', true),habilitar:false});
    }
    
    dataFimChange(e){
      this.setState({ati_data_fim:moment(e, 'YYYY-MM-DD', true)})
    }

    render() {

        if(this.state.redirect) {
          return (<Redirect to={this.props.menu.desafios.home}/>);
        }
     
        const {handleSubmit}  = this.props;
        const listaQtdTen     = [1, 2, 3];
        const listQdtTen      = listaQtdTen.map((ten, ar)  => <option key={ar} value={ten}>{ten}</option>);
           
        return (
             <div className="panel panel-default">
              <div className="panel-heading"><b>Editar desafio</b></div>
                <div className="panel-body">           
                <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                  <Field name="ati_titulo" label="Título*" component={renderField} type="text" placeholder="Título" />  
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                      <label>Tipo de desafio</label>
                      <input type="text"  className="form-control" value={this.getTipoAtividade(this.state.tipo)} disabled />
                    </div> 
                      </div>  
                      <div className="col-md-6">
                         <Field name="ati_qtd_ten" label="Quantidade de Tentativa*" component={renderFieldSelec} option={listQdtTen}/>
                      </div>   
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <Field  label="Data Ínicio*" component={renderDatePicker} name="ati_data_ini" onChange={this.dataInicioChange.bind(this)}/>
                      </div>  
                      <div className="col-md-6">
                        <Field label="Data Fim*" minData={this.state.ati_data_ini} component={renderDatePicker} habilitar={this.state.habilitar} name="ati_data_fim" onChange={this.dataFimChange.bind(this)}/>
                      </div>   
                    </div>
                    <div className="form-group">
                     <label>Unidade Curricular/Turma</label>
                     <input type="text"  className="form-control" value={this.state.disciplina} disabled />
                    </div> 
                    <Link  to={this.props.menu.desafios.home} className="btn btn-sm btn-primary pull-left">Voltar</Link>
                    <button type="submit" className="btn btn-primary btn-sm pull-right">{this.state.textButton}</button>
              </form>
            </div>
            </div>
        );
    }
}
const afterSubmit = (result, dispatch) => dispatch(reset('missoes_form'));

function mapStateToProps(state){

    return {
             session    : state.auth.session,
             formMissao : state.atividadesReducer.allAtividadesLista,
             menu       : state.configReducer.menu
            };
  }

export default reduxForm({
  form                     : 'missoes_form',
  destroyOnUnmount         : true,
  forceUnregisterOnUnmount : true,
  onSubmitSuccess          : afterSubmit,
  validate
})(connect(mapStateToProps, {SetEditarAtividades,
                             GetObterAtividade,
                             GetListaMenuTopo,
                             GetListaSubMenuTopo,
                             GetEditarAtividades,
                             SetError})(MissoesEditar));




// WEBPACK FOOTER //
// ./src/components/professor/desafios/form/desafios_editar.js